export default {
  setLoading: (state, loading) => (state.loading = loading),
  setKiosks: (state, kiosks) => (state.kiosks = kiosks),
};
